import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	moreActionsTooltip: {
		defaultMessage: 'More actions',
		id: 'jira.platform.software.context-menu.more-actions-tooltip',
		description: 'Tooltip for the meatball menu button in a software project work item',
	},
});
